import { render, staticRenderFns } from "./TemplateEventsReasonsTable.vue?vue&type=template&id=170994ba&scoped=true&"
import script from "./TemplateEventsReasonsTable.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsReasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsReasonsTable.vue?vue&type=style&index=0&id=170994ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170994ba",
  null
  
)

export default component.exports